var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAppContext } from '../contexts/AppContextProvider';
export var Button = function (_a) {
    var buttonType = _a.buttonType, _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.formName, formName = _c === void 0 ? '' : _c, _d = _a.additionalClass, additionalClass = _d === void 0 ? '' : _d;
    var className = "".concat(buttonType, "-button ").concat(additionalClass);
    var _e = useAppContext(), handleActiveStep = _e.handleActiveStep, setErrorMessage = _e.setErrorMessage, setMenuOpen = _e.setMenuOpen, setFormData = _e.setFormData;
    var handleBackClick = function () {
        handleActiveStep('navigation');
    };
    var handleCloseClick = function () {
        setMenuOpen(false);
    };
    var handleFormClick = function (form) {
        handleActiveStep(form);
        setErrorMessage('');
        setFormData({
            email: '',
            phone: '',
            zip: '',
            message: '',
        });
    };
    switch (buttonType) {
        case 'submit':
            return (_jsxs("button", __assign({ className: className, type: "submit" }, { children: [_jsx("div", { className: "loader" }), _jsx("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24", fill: "none" }, { children: _jsx("path", { d: "M7.75778 6.14799C6.84443 5.77187 6.0833 5.45843 5.49196 5.30702C4.91915 5.16036 4.18085 5.07761 3.63766 5.62862C3.09447 6.17962 3.18776 6.91666 3.34259 7.48732C3.50242 8.07644 3.8267 8.83302 4.21583 9.7409L4.86259 11.25H10C10.4142 11.25 10.75 11.5858 10.75 12C10.75 12.4142 10.4142 12.75 10 12.75H4.8626L4.21583 14.2591C3.8267 15.167 3.50242 15.9236 3.34259 16.5127C3.18776 17.0833 3.09447 17.8204 3.63766 18.3714C4.18085 18.9224 4.91915 18.8396 5.49196 18.693C6.0833 18.5416 6.84443 18.2281 7.75777 17.852L19.1997 13.1406C19.4053 13.0561 19.6279 12.9645 19.7941 12.867C19.944 12.779 20.3434 12.5192 20.3434 12C20.3434 11.4808 19.944 11.221 19.7941 11.133C19.6279 11.0355 19.4053 10.9439 19.1997 10.8594L7.75778 6.14799Z", fill: "#202427" }) }))] })));
        case 'back':
            return (_jsx("button", __assign({ className: className, onClick: handleBackClick }, { children: _jsxs("svg", __assign({ fill: "#000000", height: "65px", width: "65px", version: "1.1", viewBox: "0 0 476.213 476.213" }, { children: [_jsx("g", { strokeWidth: "0" }), _jsx("g", { strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("g", { children: _jsx("polygon", { points: "476.213,223.107 57.427,223.107 151.82,128.713 130.607,107.5 0,238.106 130.607,368.714 151.82,347.5 57.427,253.107 476.213,253.107 " }) })] })) })));
        case 'close':
            return _jsx("button", { className: className, onClick: handleCloseClick });
        case 'navigate':
            return _jsx("button", __assign({ className: className, onClick: function () { return handleFormClick(formName); } }, { children: title }));
        default:
            return null;
    }
};
